// extracted by mini-css-extract-plugin
export default {"info_modal":"infoMessage_info_modal__+3PEl","info_modal__button":"infoMessage_info_modal__button__dSqDY"};